const usingWebViewKey = 'usingWebView'

type useDecorateWebviewUrlReturnValue = (url: string) => string
export const useDecorateWebviewUrl = (): useDecorateWebviewUrlReturnValue => {
  const primitive = (url: string) => url
  const decorated = (url: string) => {
    if (url.indexOf('?') !== -1) {
      return `${url}&webview=1`
    } else {
      return `${url}?webview=1`
    }
  }

  if (window.sessionStorage[usingWebViewKey]) {
    return decorated
  } else {
    return primitive
  }
}

export const setDecorateWebviewUrlFlag = () => {
  if (location.search.indexOf('webview=1') !== -1) {
    window.sessionStorage[usingWebViewKey] = true
  }
}
